/**
 * Daily Setlist에서 제외할 곡 제목 목록
 * 시그널 뮤직이나 BGM 등 정기적으로 나오는 곡들을 관리
 */
export const EXCLUDED_TITLES: string[] = [
  'Satisfaction (타이틀 뮤직)',
  'Ballad For Kay (철수는 오늘 BGM)',
];

/**
 * 제목이 제외 목록에 있는지 확인 (대소문자 무시)
 */
export const isExcludedTitle = (title: string): boolean => {
  if (!title) return false;
  const titleLower = title.toLowerCase().trim();
  return EXCLUDED_TITLES.some((excludedTitle) => excludedTitle.toLowerCase().trim() === titleLower);
};

/**
 * 음악 데이터 배열에서 제외 목록에 해당하는 항목을 필터링
 */
export const filterExcludedTitles = <T extends { title: string }>(data: T[]): T[] => {
  return data.filter((item) => !isExcludedTitle(item.title));
};
